import React from 'react';
import { ShieldCheck } from 'lucide-react';
import Header from '@/components/layout/Header';
import FooterNew from '@/components/layout/FooterNew';

const PrivacyPage = () => {
  return (
    <div className="flex flex-col min-h-screen">
      <Header />

      <main className="flex-1">
        <section className="bg-gradient-to-br from-red-50 to-cyan-50 py-12">
          <div className="container mx-auto px-4">
            <div className="max-w-3xl mx-auto text-center">
              <ShieldCheck className="w-12 h-12 text-red-600 mx-auto mb-4" />
              <h1 className="text-4xl font-bold gradient-text mb-4">Politique de confidentialité</h1>
              <p className="text-gray-600">Dernière mise à jour : {new Date().toLocaleDateString('fr-FR')}</p>
            </div>
          </div>
        </section>

        <section className="py-12">
          <div className="container mx-auto px-4">
            <div className="max-w-4xl mx-auto prose prose-lg">
              <h2>1. Données collectées</h2>
              <p>
                Cette politique explique quelles données Coli Noki collecte, pourquoi elles sont traitées et comment elles sont protégées.
              </p>

              <h3>1.1 Compte utilisateur</h3>
              <ul>
                <li>Nom, email, téléphone, rôle, ville et organisation</li>
                <li>Création et gestion de compte</li>
              </ul>

              <h3>1.2 KYC vendeur</h3>
              <ul>
                <li>Informations entreprise et boutique</li>
                <li>Documents KYC sécurisés</li>
              </ul>

              <h3>1.3 Livraisons et suivi</h3>
              <ul>
                <li>Adresses, détails colis, statuts et historique de suivi</li>
                <li>Preuves POD et événements opérationnels</li>
              </ul>

              <h3>1.4 Paiements et portefeuille</h3>
              <ul>
                <li>Transactions de livraison et de recharge du portefeuille</li>
                <li>Références de paiement et journaux associés</li>
              </ul>

              <h3>1.5 Affiliation et newsletter</h3>
              <ul>
                <li>Liens d’affiliation, clics, inscriptions et commissions</li>
                <li>Préférences newsletter et segment marketing</li>
              </ul>

              <h2>2. Finalités</h2>
              <ul>
                <li>Créer et gérer les comptes utilisateurs</li>
                <li>Exécuter les livraisons et le suivi colis</li>
                <li>Traiter les paiements, abonnements et recharges</li>
                <li>Gérer le KYC, la confiance vendeur et la conformité</li>
                <li>Améliorer le support, la sécurité et l’exploitation</li>
              </ul>

              <h2>3. Prestataires et outils</h2>
              <ul>
                <li>Stripe pour certains paiements par carte bancaire</li>
                <li>Mailgun pour certains emails transactionnels</li>
                <li>Brevo pour les emails marketing et newsletters</li>
              </ul>

              <h2>4. Conservation et sécurité</h2>
              <p>
                Les données sont conservées selon les besoins opérationnels et légaux. Coli Noki applique des contrôles d’accès, des journaux de sécurité et des protections techniques raisonnables.
              </p>

              <h2>5. Vos droits</h2>
              <ul>
                <li>Accès et rectification</li>
                <li>Suppression selon les limites légales applicables</li>
                <li>Contact pour toute demande liée à la vie privée</li>
              </ul>

              <h2>6. Contact</h2>
              <p>
                Pour toute demande relative à vos données : privacy@colinoki.com
              </p>
            </div>
          </div>
        </section>
      </main>

      <FooterNew />
    </div>
  );
};

export default PrivacyPage;
